var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1027_7279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16L12 12M12 12L8.00002 16M12 12V21M20.39 18.39C21.3654 17.8583 22.1359 17.0169 22.5799 15.9986C23.0239 14.9804 23.1162 13.8432 22.8422 12.7667C22.5682 11.6901 21.9435 10.7355 21.0667 10.0534C20.1899 9.37137 19.1109 9.00072 18 8.99998H16.74C16.4373 7.82923 15.8732 6.74232 15.09 5.82098C14.3068 4.89964 13.3249 4.16783 12.2181 3.68059C11.1114 3.19335 9.90857 2.96334 8.70014 3.00787C7.4917 3.05239 6.30909 3.37028 5.2412 3.93765C4.17331 4.50501 3.24793 5.30709 2.53464 6.28357C1.82135 7.26004 1.33871 8.38552 1.123 9.57538C0.907291 10.7652 0.964126 11.9885 1.28923 13.1532C1.61434 14.318 2.19926 15.3938 3.00002 16.3",
    stroke: "",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1027_7279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.915c1365abc4efdae7f7973cbc091d71.svg";
export { ForwardRef as ReactComponent };